import type { IconProps } from "./icon-types";

/**
 * 여러 항목이 한 묶음으로 합쳐진 cluster. 얕게 포개진 세 layer로 그룹을 나타낸다.
 *
 * 사각형을 복제하는 CopyIcon과 달리 위쪽 면 + 아래쪽 두 layer의 수직 stack을 사용한다.
 * 개수는 아이콘 안에 겹치지 않고 소비처가 인접한 text로 composition한다.
 */
export const ClusterIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="m12 3 9 5-9 5-9-5 9-5Z" />
    <path d="m3 12 9 5 9-5" />
    <path d="m3 16 9 5 9-5" />
  </svg>
);
